import { render, staticRenderFns } from "./ModalCheckoutCash.vue?vue&type=template&id=565408c6"
import script from "./ModalCheckoutCash.vue?vue&type=script&lang=js"
export * from "./ModalCheckoutCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports